import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
export var updateEditUserName = mutatorAction('updateEditUserName', function (username) {
    var store = connectedAccountsStore();
    store.editAccountState.username = username;
});
//# sourceMappingURL=updateEditUserName.js.map